export const CATEGORIES = [
  {
    id: "Resort Centers",
    label: "Resort Centers",
  },
  {
    id: "Restaurant",
    label: "Restaurant",
  },
  {
    id: "Hotels",
    label: "Hotels",
  },
  {
    id: "Guest House/ Pension",
    label: "Guest House/ Pension",
  },
  {
    id: "Pharmacy",
    label: "Pharmacy",
  },
  {
    id: "Veterinary",
    label: "Veterinary",
  },
  {
    id: "Secondary School",
    label: "Secondary School",
  },
  {
    id: "Research & Training Centers",
    label: "Research & Training Centers",
  },
  {
    id: "Hospitals",
    label: "Hospitals",
  },
  {
    id: "University",
    label: "University",
  },
  {
    id: "ATM",
    label: "ATM",
  },
  {
    id: "Poultry",
    label: "Poultry",
  },
  {
    id: "Mosque",
    label: "Mosque",
  },
  {
    id: "Orthodox Tewahedo Church",
    label: "Orthodox Tewahedo Church",
  },
  {
    id: "Protestant Church",
    label: "Protestant Church",
  },
  {
    id: "Catholic Church",
    label: "Catholic Church",
  },
];

export const REGIONS = [
  {
    id: "Addis Ababa",
    label: "Addis Ababa",
  },
  {
    id: "Afar",
    label: "Afar",
  },
  {
    id: "Amhara",
    label: "Amhara",
  },
  {
    id: "Benishangul-Gumuz",
    label: "Benishangul-Gumuz",
  },
  {
    id: "Dire Dawa",
    label: "Dire Dawa",
  },
  {
    id: "Gambela",
    label: "Gambela",
  },
  {
    id: "Harari",
    label: "Harari",
  },
  {
    id: "Oromia",
    label: "Oromia",
  },
  {
    id: "Sidama",
    label: "Sidama",
  },
  {
    id: "Somali",
    label: "Somali",
  },
  {
    id: "South West Ethiopia Peoples",
    label: "South West Ethiopia Peoples",
  },
  {
    id: "Southern Nations, Nationalities, and Peoples",
    label: "Southern Nations, Nationalities, and Peoples",
  },
  {
    id: "Tigray",
    label: "Tigray",
  },
];

export const DEFAULT_VALUES = {
  legal_name: "",
  function_t: "",
  region: "",
  city_name: "",
  village_na: "",
  website: "",
  contactInfo: "",
  parking_fa: false,
};
